import React from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { LogOut } from 'lucide-react';

const DashboardHeader = ({ user, onLogout }) => {
  const navigate = useNavigate();

  return (
    <nav className="bg-white/80 dark:bg-slate-900/90 backdrop-blur-lg border-b border-gray-200 dark:border-slate-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-16">
          <div className="flex items-center space-x-2 sm:space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <div className="w-8 h-8 sm:w-10 sm:h-10">
              <img 
                src="https://customer-assets.emergentagent.com/job_ai-content-hub-47/artifacts/3puy1tgr_Viralla%20AI%20No%20Text%20Transparent.png" 
                alt="Viralla AI Logo" 
                className="w-8 h-8 sm:w-10 sm:h-10 object-contain"
              />
            </div>
            <div>
              <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
                Viralla AI
              </span>
              <div className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium -mt-1 hidden sm:block">
                Go Viral. Stay Authentic.
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-2 sm:space-x-4">
            <ThemeToggle variant="icon" className="text-gray-600 hover:text-purple-600 hover:bg-purple-50 dark:text-gray-300 dark:hover:text-purple-400 dark:hover:bg-purple-900/30" />
            {user && (
              <>
                <Badge 
                  variant="outline" 
                  className="bg-blue-50 text-blue-700 border-blue-200 cursor-pointer hover:bg-blue-100 hover:border-blue-300 transition-colors text-xs sm:text-sm hidden sm:inline-flex dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-700"
                  onClick={() => navigate('/profile')}
                >
                  {user.firstName} {user.lastName}
                </Badge>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onLogout}
                  className="flex items-center space-x-1 sm:space-x-2 text-gray-600 hover:text-red-600 hover:border-red-300 text-xs sm:text-sm px-2 sm:px-3 dark:text-gray-300"
                >
                  <LogOut className="w-4 h-4" />
                  <span className="hidden sm:inline">Logout</span>
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default DashboardHeader;
